import { createHighlightMarker } from 'app/core/markers/models';
import { InsertPathBased } from './InsertPathBased';
export const InsertHighlight = () => {
    const createMarker = (point) => createHighlightMarker({
        x: point.x,
        y: point.y,
        size: 15 /* MarkerSize.s5 */ * 2,
    });
    return InsertPathBased(createMarker);
};
